import Vue from 'vue'
import SharedService from '@/services/SharedService'

export default {
  // current node environment
  env: process.env.NODE_ENV,

  getModule(id) {
    return Vue.http.get('modules/' + id)
      .then(SharedService.extractData)
  },

  getMyModules() {
    return Vue.http.get('modules')
      .then(SharedService.extractData)
  },

  getGroupModules(groupId) {

  },

  submitModuleForm(formData) {
    return Vue.http.post('module_response/' + formData.moduleId, formData)
      .then(SharedService.extractData)
  }
}
